
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTabSelected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 126,
  viewBox: "0 0 44 126"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "tab-selected_4db2bf5c81836bdf__a",
  x1: "55.267%",
  x2: "43.156%",
  y1: "74.366%",
  y2: "19.152%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("filter", {
  id: "tab-selected_4db2bf5c81836bdf__b",
  width: "293.2%",
  height: "167.5%",
  x: "-96.6%",
  y: "-33.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 2,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -7,
  dy: 2,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#tab-selected_4db2bf5c81836bdf__b)",
  fill: "url(#tab-selected_4db2bf5c81836bdf__a)",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 36.965a10 10 0 0 1 7.913-9.78c13.967-2.98 22.311-5.63 25.032-7.95 3.201-2.728 4.985-9.14 5.353-19.235 2.905 0 4.683 1.755 5.332 5.266.489 1.186.493 20.431.013 57.734.48 37.303.476 56.548-.013 57.734-.65 3.51-2.427 5.266-5.332 5.266-.368-10.095-2.152-16.507-5.353-19.235-2.721-2.32-11.065-4.97-25.032-7.95A10 10 0 0 1 0 89.035v-52.07z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"126\" viewBox=\"0 0 44 126\">\r\n    <defs>\r\n        <linearGradient id=\"ykgkqy2y2a\" x1=\"55.267%\" x2=\"43.156%\" y1=\"74.366%\" y2=\"19.152%\">\r\n            <stop offset=\"0%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n            <stop offset=\"100%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n        </linearGradient>\r\n        <filter id=\"sc5um39mxb\" width=\"293.2%\" height=\"167.5%\" x=\"-96.6%\" y=\"-33.7%\" filterUnits=\"objectBoundingBox\">\r\n            <feMorphology in=\"SourceAlpha\" operator=\"dilate\" radius=\"2\" result=\"shadowSpreadOuter1\"/>\r\n            <feOffset dx=\"-7\" dy=\"2\" in=\"shadowSpreadOuter1\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"7\"/>\r\n            <feColorMatrix in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"url(#ykgkqy2y2a)\" transform=\"translate(-1367 -251)\">\r\n            <g filter=\"url(#sc5um39mxb)\" transform=\"translate(1367 251)\">\r\n                <path d=\"M0 36.965c0-4.718 3.298-8.795 7.913-9.78 13.967-2.98 22.311-5.63 25.032-7.95 3.201-2.728 4.985-9.14 5.353-19.235 2.905 0 4.683 1.755 5.332 5.266.489 1.186.493 20.431.013 57.734.48 37.303.476 56.548-.013 57.734-.65 3.51-2.427 5.266-5.332 5.266-.368-10.095-2.152-16.507-5.353-19.235-2.721-2.32-11.065-4.97-25.032-7.95C3.298 97.83 0 93.753 0 89.035v-52.07z\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/tab-selected.4db2bf5c81836bdf84ee11e85e4026f0.svg"),
        {
          React: SvgTabSelected,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      